import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Chip8 from './components/chip8';


ReactDOM.render(<Chip8 />, document.getElementById('root'));



